/* eslint-disable import/prefer-default-export */
import {
  MenuMessages,
  TranslationMenuMessages
} from "../interfaces";

export const messages: TranslationMenuMessages = {
  [MenuMessages.production]: "Produção",
  [MenuMessages.pumps]: "Bombas",
  [MenuMessages.supportVehicles]: "Veículos de apoio",
  [MenuMessages.trucks]: "Carretas",
  [MenuMessages.dashboards]: "Dashboards",
  [MenuMessages.management]: "Gereciamento",
  [MenuMessages.users]: "Usuários",
  [MenuMessages.modules]: "Módulos",
  [MenuMessages.drivers]: "Motoristas",
  [MenuMessages.vehicles]: "Veículos",
  [MenuMessages.locations]: "Locais",
  [MenuMessages.hardwares]: "Hardwares",
  [MenuMessages.SIMCards]: "SIM Cards",
  [MenuMessages.reports]: "Relatórios",
  [MenuMessages.scheduledReports]: "Relatórios agendados",
  [MenuMessages.travelHistory]: "Histórico de viagens",
  [MenuMessages.alertHistory]: "Histórico de alertas e eventos",
  [MenuMessages.averageSpeed]: "Velocidade média",
  [MenuMessages.coordinateAnalysis]: "Análise de coordenadas",
  [MenuMessages.vehicleHistory]: "Histórico de veículos",
  [MenuMessages.vehicleCanHistory]: "Histórico de veículos - CAN",
  [MenuMessages.vehicleStatesHistory]: "Histórico de estados de veículo",
  [MenuMessages.waterAdditionHistory]: "Histórico de adições de água",
  [MenuMessages.canHistory]: "Histórico CAN",
  [MenuMessages.odometerHourmeterReport]: "Odômetro/Horímetro Total",
  [MenuMessages.others]: "Outros",
  [MenuMessages.contactUs]: "Fale conosco",
  [MenuMessages.settings]: "Configurações",
  [MenuMessages.installApp]: "Instalar aplicativo",
  [MenuMessages.exit]: "Sair",
  [MenuMessages.generalLocation]: "Localização geral",
  [MenuMessages.vehiclesUnderMaintenance]: "Veículos em manutenção",
  [MenuMessages.alerts]: "Alertas",
  [MenuMessages.speedingAlerts]: "Alerta de limite de velocidade",
  [MenuMessages.canAlerts]: "Alertas CAN",
  [MenuMessages.concreteExpiration]: "Validade do concreto",
  [MenuMessages.improperDischarges]: "Descarregamentos indevidos",
  [MenuMessages.vehiclesInTrustedLocations]: "Veículos em locais confiáveis",
  [MenuMessages.blockedVehicles]: "Veículos bloqueados",
  [MenuMessages.regionals]: "Regionais",
  [MenuMessages.help]: "Ajuda",
  [MenuMessages.groups]: "Grupos",
  [MenuMessages.pumpProgramming]: "Programação de bombas",
  [MenuMessages.relatedMixersDetails]: "Betoneiras Relacionadas",
  [MenuMessages.zones]: "Zonas de Restrição",
  [MenuMessages.driversRoles]: "Cargos dos motoristas",
  [MenuMessages.travelAnalysis]: "Análise de viagens",
  [MenuMessages.registration]: "Cadastro",
  [MenuMessages.operation]: "Operação",
  [MenuMessages.equipment]: "Equipamentos",
  [MenuMessages.administration]: "Administração",
  [MenuMessages.documentation]: "Documentação",
  [MenuMessages.support]: "Suporte",
  [MenuMessages.docsManual]: "Manual & Novidades",
  [MenuMessages.newVersionBanner]: "Nova versão {{version}}! Veja o que há de novo.",
  [MenuMessages.newVersionSee]: "Ver novidades",
  [MenuMessages.newVersionDismiss]: "Marcar como lido",
  [MenuMessages.newBadge]: "Novo",
  [MenuMessages.reportsTravel]: "Relatórios — Viagens",
  [MenuMessages.reportsVehicle]: "Relatórios — Veículos",
  [MenuMessages.reportsMonitoring]: "Relatórios — Monitoramento",
  [MenuMessages.reportsRequested]: "Relatórios — Solicitados"
};
